'use strict';

const whereIsMyOrderFormHandler = require('./whereIsMyOrder/whereIsMyOrderFormHandler'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    removeParamFromURL = require('../modules/util/removeParamFromURL'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    isMobileOrTabletWidth = require('../modules/util/isMobileOrTabletWidth');

const dataLayer = window.dataLayer || [];

const stickyMobileDropdown = function() {
    const $stickyDropdown = $('.js-faq-theme-mobile-dropdown');

    if (!$stickyDropdown.length) {
        return;
    }
    const $stickyDropdownHolder = $('.js-faq-theme-mobile-dropdown-placeholder');
    const stickyDropdownHolderRect = $stickyDropdownHolder[0].getBoundingClientRect().top;
    const stickyDropdownHeight = $stickyDropdown.outerHeight();
    $stickyDropdownHolder.css('height', stickyDropdownHeight);

    if (stickyDropdownHolderRect <= 0) {
        $stickyDropdown.addClass('sticky');
        $stickyDropdownHolder.addClass('in-place');
        return;
    }

    $stickyDropdown.removeClass('sticky');
    $stickyDropdownHolder.removeClass('in-place');
};

function faqAccordionToggle(button, updateURL) {
    const faqHeadClass = '.js-faq-theme-acc-head';
    const faqContentClass = '.js-faq-theme-acc-content';
    const $parent = button.parent(faqHeadClass);
    const $siblings = $parent.parent().siblings();

    if (!$parent.hasClass('open-acc')) {
        $siblings.find(faqHeadClass).removeClass('open-acc').attr('aria-expanded', 'false');
        $siblings.find(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
        $parent.addClass('open-acc').attr('aria-expanded', 'true');
        $parent.siblings(faqContentClass).stop().slideDown().attr('aria-hidden', 'false');
        if (updateURL) {
            const url = replaceParameterInUrl(window.location.href, button.data('parameter-name'), button.data('article-id'));
            setUrl(url);
        }
        return;
    }

    $parent.removeClass('open-acc').attr('aria-expanded', 'false');
    $parent.siblings(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
    if (updateURL) {
        const url = removeParamFromURL(window.location.href, button.data('parameter-name'));
        setUrl(url);
    }
}

const faqRedesign = {
    init : function() {
        whereIsMyOrderFormHandler.init();
        loadSelectedTopicAndArticleFromURL();

        $(document).on('click', '.js-faq-nav-button', function () {
            setActiveTopic($(this).data('topic-id'), true);
        });

        $(document).on('change', '.js-dropdown-select', function () {
            setActiveTopic($(':selected', $(this)).data('topic-id'), true);
        });

        initAccoridanBtn();
        initDataLayerPush();

        $(document).on('click', '.js-data-layer-element', function(e) {
            pushDataToDataLayer($(e.currentTarget));
        });

        $(document).on('click', '.js-faq-theme-back-button', function () {
            window.history.back();
        });

        if (isMobileOrTabletWidth()) {
            stickyMobileDropdown();
            $(window).on('scroll', stickyMobileDropdown);
        }

        $(document).off('faq.pushDataLayerObject').on('faq.pushDataLayerObject', function(_, params) {
            if (!params || !params.length) {
                return;
            }
            const $findMyOrderButton = params.filter('.js-find-my-order-button');
            pushDataToDataLayer($findMyOrderButton);
        });
    },
    initCheckout : function() {
        initAccoridanBtn();
        initDataLayerPush();
    }
};

function initAccoridanBtn() {
    $(document).off('click', '.js-faq-theme-acc-head-button').on('click', '.js-faq-theme-acc-head-button', function(e) {
        faqAccordionToggle($(e.target), true);
    });
}

function initDataLayerPush() {
    $(document).off('click', '.js-data-layer-element').on('click', '.js-data-layer-element', function(e) {
        pushDataToDataLayer($(e.currentTarget));
    });
}

function loadSelectedTopicAndArticleFromURL() {
    const params = getQueryStringParams(window.location.href),
        topic = params['catid'],
        article = params['qid'];

    setActiveTopic(topic, false, article);
}

function setActiveTopic(topic, updateUrl, article) {
    const $topicElement = getTopicElement(topic);
    const $topicMobileElement = getTopicMobileElement(topic);

    if (!$topicElement || !$topicMobileElement) {
        return;
    }

    $('button', '.js-faq-nav').removeClass('active');
    $topicElement.addClass('active');
    const $topicBreadcrumbElement = $('.js-breadcrumb-element-topic', '.js-faq-nav');
    $('span', $topicBreadcrumbElement).text($topicElement.data('topic-header'));
    $('option', '.js-dropdown-select').removeAttr('selected');
    $topicMobileElement.attr('selected', 'selected');

    updateArticlesAndDIY($topicElement.data('articles-content-id'), article, $topicElement.data('diy-content-id'));

    if (updateUrl) {
        let url = removeParamFromURL(window.location.href, 'qid');
        url = replaceParameterInUrl(url, $topicElement.data('parameter-name'), $topicElement.data('topic-id'));
        setUrl(url);
    }
}

function getTopicElement(topic) {
    let $topicToBeSelected = $('button[data-topic-id="' + topic + '"]', '.js-faq-nav');
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('button', '.js-faq-nav')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function getTopicMobileElement(topic) {
    let $topicToBeSelected = $('option[data-topic-id="' + topic + '"]','.js-dropdown-select');

    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('option', '.js-dropdown-select')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function getArticleElement(article) {
    const $articleToBeSelected = $('button[data-article-id="' + article + '"].js-faq-theme-acc-head-button');

    if ($articleToBeSelected && $articleToBeSelected.length) {
        return $articleToBeSelected;
    }

    return false;
}

function setUrl(url){
    url = url.replace('?&', '?');
    if (url[url.length - 1] == '?') {
        url = url.slice(0, -1);
    }

    window.history.replaceState([], null, url);
}

function replaceParameterInUrl(url, name, value){
    const clean = removeParamFromURL(url, name);
    return appendParamToURL(clean, name, value);
}

function updateArticlesAndDIY(articlesContentID, article, diyContentID) {
    $.ajax({
        type: 'GET',
        url: Urls.getArticleAndDIYBlocks,
        data: 'articlesContentID=' + articlesContentID + '&diyContentID=' + diyContentID,
        success: function(response) {
            const $data = $(response);
            const $articlesHTML = $data.filter('.js-articles').children();
            const $diyHTML = $data.filter('.js-diy').children();

            $('.js-faq-accordion-wrapper').empty().append($articlesHTML);
            $('.js-faq-diy-wrapper').empty().append($diyHTML);
            const $articleElement = getArticleElement(article);
            if ($articleElement){
                faqAccordionToggle($articleElement, false);
            }
        }
    });
}

function pushDataToDataLayer(element) {
    if (!element || !element.length) {
        return;
    }

    let dataLayerLabel = element.data('data-layer');
    if (!dataLayerLabel) {
        return;
    }
    dataLayerLabel = decodeURIComponent(dataLayerLabel);

    const dataLayerObject = {
        event: 'faq',
        category: 'faq',
        action: 'click faq',
        label: dataLayerLabel
    };

    bindBlockSpecificDataLayerAttributes(element, dataLayerObject);

    dataLayer.push(dataLayerObject);
}

function bindBlockSpecificDataLayerAttributes(element, dataLayerObject) {
    const $faqDIYBlock = element.closest('.js-faq-diy-wrapper');
    if ($faqDIYBlock && $faqDIYBlock.length) {
        dataLayerObject.action = 'do it yourself';
        return;
    }

    const $faqQuestionFormBlock = element.closest('.js-faq-question-form-blocks');
    if (!$faqQuestionFormBlock || !$faqQuestionFormBlock.length) {
        return;
    }

    dataLayerObject.category = 'wimo';

    const $wimoFormWrapper = element.closest('.js-wimo-form-wrapper');

    if (!$wimoFormWrapper || !$wimoFormWrapper.length) {
        return;
    }

    dataLayerObject.action = 'click';
    dataLayerObject.event = element.hasClass('js-find-my-order-button') ? 'order_inquiry_form' : 'login';
}

module.exports = faqRedesign;
